<template>
    <v-hover v-slot:default="{ hover }" open-delay="50">
        <v-card :elevation="hover ? 8 : 0" class="card-shadow">
            <div class="offer-label-area">
                <div
                    v-if="offer.extra.use_label"
                    class="trapezoid"
                    :style="{
                        background: offer.extra.label_color ? offer.extra.label_color : '#2196F3',
                    }"
                ></div>
                <div class="offer-label">
                    {{ offer.extra.label_text }}
                </div>
            </div>
            <v-card-title class="pa-0">
                <v-row class="ma-1" align="center">
                    <v-col cols="6" class="pa-2" align="center" justify="center">
                        <v-img
                            v-bind:src="offer.img_path"
                            height="50px"
                            width="180px"
                            contain
                            @click="openOffer(offer.affiliate_url, offer)"
                            alt="Placeholder image"
                            style="cursor: pointer;"
                        >
                        </v-img>
                    </v-col>
                    <v-col cols="6" class="pa-0" align="center" justify="center">
                        <v-rating
                            v-model="offer.rate"
                            half-increments
                            background-color="orange lighten-3"
                            color="orange"
                            medium
                            dense
                            readonly
                        ></v-rating>
                    </v-col>
                </v-row>
            </v-card-title>

            <v-divider class="ma-0"></v-divider>

            <v-card-text class="pb-0">
                <v-row align="start" justify="center" class="px-3">
                    <v-col cols="6" class="pa-0">
                        <p class="mb-0 offer-text text--grey">{{ $t("loan_sum") }}</p>
                        <p class="offer-text--bold">
                            {{ $t("up_to_x_currency", { sum: offer.sum }) }}
                            {{ $t("currency_symbol") }}
                        </p>
                    </v-col>
                    <v-col cols="6" class="pa-0">
                        <p class="mb-0 offer-text text--grey">{{ $t("percentage_rate") }}</p>
                        <p class="offer-text--bold">
                            {{ $t("from_x_percent_in_day", { bet: offer.bet }) }}
                        </p>
                    </v-col>
                </v-row>
                <v-row align="start" justify="center" class="px-3">
                    <v-col cols="6" class="pa-0">
                        <p class="mb-0 offer-text text--grey">{{ $t("loan_period") }}</p>
                        <p class="offer-text--bold">
                            {{ $t("up_to_x_days", { days: offer.days }) }}
                        </p>
                    </v-col>
                    <v-col cols="6" class="pa-0">
                        <p class="mb-0 offer-text text--grey">{{ $t("success_rate") }}</p>
                        <v-row align="center" justify="center" class="px-3">
                            <v-col class="offer-text--bold pa-0">
                                <span class="text--green">{{ offer.success_rate }}%</span>
                            </v-col>
                            <v-col class="pa-0" cols="8">
                                <v-progress-linear
                                    :value="offer.success_rate"
                                    height="5"
                                    color="green"
                                ></v-progress-linear>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-card-text>

            <v-card-actions>
                <v-row dense>
                    <v-col align="center" justify="center" cols="12">
                        <v-btn
                            :color="color ? color : 'primary'"
                            @click="openOffer(offer.affiliate_url, offer)"
                            class="w95"
                            depressed
                        >
                            <div class="text-left offer-button">{{ $t("get_money") }}</div>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-actions>
        </v-card>
    </v-hover>
</template>

<script>
export default {
    name: "Offer",
    props: ["offer", "is_clickable", "color"],
    data() {
        return {
            price: 12,
            days: 12,
        };
    },
    computed: {
        settings() {
            return this.$store.getters.APP_SETTINGS;
        },
        user() {
            return this.$store.getters.AUTH_USER;
        },
    },
    methods: {
        openOffer(url, offer) {
            if (
                this.settings.payments.enabled &&
                this.settings.payments.offer &&
                !this.user.cc_attached
            ) {
                this.$store.dispatch("OPEN_PAYMENTS_MODAL", true);
                return;
            }
            if (this.is_clickable) {
                let chosen_offer = {
                    offer: offer.id,
                    sum: this.price,
                    days: this.days,
                    aff_sub3: offer.lead_uuid,
                    pattern_id: offer.pattern_id,
                };
                this.$store.dispatch("CHOSE_OFFER", chosen_offer);

                if (
                    sessionStorage.getItem("source") != "" &&
                    sessionStorage.getItem("source") != null
                ) {
                    var re = new RegExp("\A?aff_sub4=[^&]+", "i");
                    if (url.match(re)) {
                        url = url.replace(re, "aff_sub4=" + sessionStorage.getItem("source"));
                    } else {
                        re = new RegExp("\A?s4=[^&]+", "i");
                        if (url.match(re)) {
                            url = url.replace(re, "s4=" + sessionStorage.getItem("source"));
                        }
                    }
                }
                window.open(url, "_blank");
            }
        },
    },
};
</script>

<style>
.offer-button {
    font-size: 13px;
}
.offer-text--bold {
    font-family: "Mont Bold";
    font-style: normal;
    font-weight: 800;
    font-size: 18px;
    line-height: 20px;
    color: #282828;
}
.offer-text {
    font-style: normal;
    font-weight: 600;
    font-size: 13px;
    line-height: 17px;
}
.trapezoid {
    transform: perspective(6px) rotateX(-1deg);
    border-radius: 6px;
    height: 30px;
    width: 100%;
    position: absolute;
}
.offer-label {
    width: 100%;
    height: 30px;
    color: white;
    line-height: 30px;
    text-align: center;
    font-size: 14px;
    font-weight: 500;
    position: relative;
}
.offer-label-area {
    width: 95%;
    position: relative;
    margin: 0 auto;
}
</style>
